import React, { useEffect, useRef, useState } from "react";
import SelectComponent from "./SelectComponent";
import { ClickAwayListener } from "@mui/material";
import useClickOutside from "../../hooks/Screen/useClickOutside";
import { safeJsonParse } from "../../utils/utilityFunctions/stringUtility";

const CombinedSingleAndMultiSelect = ({
  // activeCell,
  setActiveCell,
  dropdownData,
  cell,
  UpdateTableField,
  FieldValue,
  Item,
  type,
  noFormInput,
}) => {
  const [listOpen, setListOpen] = useState(false);

  const selectedOptionsRef = useRef(
    type === "multiselect" && Array.isArray(safeJsonParse(FieldValue))
      ? safeJsonParse(FieldValue)?.map((item) => ({
          value: item?.uuid ?? item?.id ?? item?.value,
          label: item?.label ?? item?.value,
          color_code: item?.color_code,
        }))
      : type === "dropdown"
        ? [
            {
              value:
                safeJsonParse(FieldValue)?.uuid ?? safeJsonParse(FieldValue)?.id ?? safeJsonParse(FieldValue)?.value,
              label: safeJsonParse(FieldValue)?.value,
              color_code: safeJsonParse(FieldValue)?.color_code,
            },
          ]
        : []
  );

  const handleOptionClick = (value) => {
    if (type === "dropdown") {
      // for dropdown, we need to send just the single object in payload thats why accessing only the zeroth index of value,
      // our select domponent, return the value in form of array of objects
      UpdateTableField("", noFormInput ? value[0] : value.target.value, Item, cell);
    }
  };

  //this function is for sending the multiselctdata, as we cant handle this using our handleoptionclick function
  const handleSendIconClick = (value) => {
    UpdateTableField("", noFormInput ? value : value.target.value, Item, cell);
  };

  useEffect(() => {
    setListOpen(true);
  }, []);

  return (
    <SelectComponent
      // options={dropdownData?.map((item) => ({
      //   value: item?.uuid ?? item?.id ?? item.value,
      //   label: item.value,
      //   color_code: item.color_code,
      // }))}
      options={dropdownData}
      valueKey="id"
      labelKey="value"
      showSearch={true}
      value={selectedOptionsRef?.current}
      {...(type == "multiselect" && { multiSelect: true })}
      onChange={handleOptionClick}
      listOpen={true}
      listCloseHandler={(value) => {
        if (type === "dropdown") {
          setActiveCell({ rowId: null, columnId: null });
        } else {
          setActiveCell({ rowId: null, columnId: null });
          UpdateTableField("", value, Item, cell);
        }
      }}
      noFormInput={noFormInput}
      handleSendIconClick={handleSendIconClick}
      showCheckBox={type === "multiselect" ? true : false}
      isCompareValue="value"
    />
  );
};

export default CombinedSingleAndMultiSelect;
